import axios from './axiosConfig';
//import { createBrowserHistory } from "history";
//const API_URL = "https://api.demo1.raborisk.ai";
const API_URL = process.env.NODE_ENV === 'production' 
    ? "https://api.demo1.raborisk.ai" 
    : "http://localhost:3000";

    
export const resetSettingsUpdated = () => {
    return (dispatch) => {
        dispatch({ type: "SETTINGS_UPDATED_RESET", settings_updated: null });
    };
};

export const resetErrorMessage = () => {
    return (dispatch) => {
        dispatch({ type: "ERROR_MESSAGE", error_message: null });
    };
};

export const updateSettings = (settings) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/user/update_settings/", settings)
            .then(({ data }) => {
                //alert("Settings updated");
                dispatch({ type: "SETTINGS_UPDATED", settings: data });
            }).catch((error) => {
                dispatch({ type: "ERROR_MESSAGE", error_message: error.response.data.message });
            });
    };
};

export const getSettings = () => {
    return (dispatch) => {
        axios.get(API_URL + "/api/user/get_settings/")
            .then(({ data }) => {
                dispatch({ type: "SETTINGS", settings: data });
            });
    };
};